<app-portal-message [successMsg]="successMsg" [errMsg]="errMessage"></app-portal-message>
